<template>
  <div class="wellcome">
  <HLCardLayout class="pt-0" :scale="(isTabletOrPhone)?((isSmAndUpDevice && !isInLandscape)?0.7:0.95):(isXlDevice)?0.4:0.7" :loading="_.isEmpty(selectedEvent)" :minHeight="(isSmAndUpDevice)?'600':null" disablePadding disableFooterPadding :horizontalMargin="true">
    <template #menuTitle>
      <h3 class="three-dots px-sm-6 grey--text text--darken-3" :style="{'color': theme.textColor + '!important'}" :class="{'text-center':!showStepInfo}">{{title}}</h3>
    </template>

    <!-- Content -->
    <template #content>
      <div class="px-6 px-sm-12" :class="{'pt-12 mt12':!changeTeamFoto && showStepTeam}">
        <div class="text-sm-h6 text-center pb-5 m-auto" :style="{'color': theme.textColor + '!important'}"><span v-html="description"></span></div>
        <div v-if="!_.isEmpty(selectedEvent)" >
          <EspSettingsViewParticipants v-show="showStepParticipants" v-if="hasStepParticipants"
          v-model="getStepperViewByName('participants').valid" 
          :eventId="selectedEventId" 
          :isMobile="isSmAndDownDevice"
          @complete="onParticipantsSettingsComplete"/>

          <EspSettingsViewTeam v-show="showStepTeam" v-if="hasStepTeam"
          v-model="getStepperViewByName('team').valid" 
          ref="teamView"
          :eventId="selectedEventId" 
          :changeName="changeTeamName" 
          :changeFoto="changeTeamFoto"
          :isMobile="isSmAndDownDevice"
          @complete="onTeamSettingsComplete"/>

          <div v-show="!showStepTeam && !showStepParticipants && showStepInfo" class="text-sm-h6" :style="{'color': theme.textColor }" v-html="eventDescr"/>
        </div>
      </div>

    </template>
    <template #footer>
      <v-row v-if="!_.isEmpty(selectedEvent)" no-gutters class="pt-1" >
        <!-- Button prev -->
        <v-col cols="4" md="4" align="start">
          <v-btn
            v-show="showPrevButton"
            class=""
            elevation="0"
            fab
            dark
            small
            @click.stop="onGoPrev"
            :color="theme.textColor"
          >
            <v-icon dark opacity="0.5" :color="theme.backgroundColor">
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>
        <!-- Footer -->
        <v-col cols="4" md="4" align="center" >
          <!-- stepper -->
          <v-row no-gutters class="welcomeDialog" align="center" >
            <v-col cols="12" align="center">
            <v-stepper v-show="visibleItems.length>1" class="elevation-0 text-caption" :style="{'background-color':theme.headerFooterColor, 'width':vStepperWidth, 'border-radius':'20px'}">
              <v-stepper-header style="height:40px;">
                <v-stepper-step v-for="(item) in visibleItems" :key="item.id" complete-icon="checkbox-blank-circle-outline" :color="theme.footerIconSelectedColor" @click="editableStep(item.id)" :class="isClickableStepClass(item.id)" :complete="completed(item.id)" step=""></v-stepper-step>
              </v-stepper-header>
            </v-stepper>
            </v-col>
          </v-row>
        </v-col>
        <!-- Button Next-->
        <v-col cols="4" md="4" align="end" style="text-align: end;">
          <v-btn
            v-if="showNextButton &&!completedWelcomeDialog && getStepperView()"
            :disabled="!getStepperView().valid"
            :class="{active:interval}"
            elevation="0"
            fab
            :dark="getStepperView().valid"
            small
            @click.stop="onGoNext"
            :color="theme.textColor"
            @mousedown="start"
            @touchstart="start"
            @mouseleave="stop"
            @mouseup="stop"
            @touchend="stop"
            @touchcancel="stop"
            class="wellcome-button"
          >
            <v-icon dark opacity="0.5" :color="theme.backgroundColor">
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-btn v-else-if="getStepperView()"
          large 
          :disabled="!getStepperView().valid"
          depressed 
          :color="theme.btnColorPrimary" 
          rounded  
          class="white--text"
          style="max-width: 100%;"
          @click.stop="onClose"><span :style="{'color':theme.btnTextColor}">{{$t('start')}}</span>
            <v-icon dark opacity="0.5" :color="theme.btnTextColor">
              mdi-chevron-right
            </v-icon>
            </v-btn>
        </v-col>
      </v-row>
    </template>
  </HLCardLayout>
  </div>
</template>

<script>
import {layoutMixin} from '../../utils/layout-mixin'
import {settingsMixin} from '../../utils/settings-mixin'
import {eventMixin} from '../../utils/event-mixin'
import {teamMixin} from '../../utils/team-mixin'
import {spotMixin} from "../../utils/spot-mixin";
import HLCardLayout from '../../components/dashboard/HLCardLayout.vue'
import EspSettingsViewParticipants from '../../components/settings/EspSettingsViewParticipants.vue'
import EspSettingsViewTeam from '../../components/settings/EspSettingsViewTeam.vue'
import Utils from "../../store/modules/base";

export default {
  mixins: [layoutMixin,settingsMixin,eventMixin,teamMixin,spotMixin],
  components:{
    HLCardLayout,
    EspSettingsViewParticipants,
    EspSettingsViewTeam
  },
  props: {
    spanColor: {},
    btnColor: {},
    backgroundColor: {}
  },
  data(){
    return {
      wizardStep:1,
      highestWizardStep:1,
      items:[
        {
          id:1,
          name:'info',
          visible:true,
          valid:true
        },
        {
          id:2,
          name:'team',
          visible:true,
          valid:false
        },
        {
          id:3,
          name:'participants',
          visible:true,
          valid:false
        }
      ],
      enteredTeamSettings:{},
      enteredParticipatSettings:[],
      interval:false,
      count:0,
      spanColorValue: this.spanColor,
      btnColorValue: this.btnColor,
      backgroundColorValue: this.backgroundColor,
      vStepperWidth: '100%'
    }
  },
  mounted() {
      this.assignPseudoElementStyle();
      this.setPaginationWidth();
  },
  watch:{
    'selectedEventId': {
      handler(id) {
        if(id){
          if(this.selectedEvent){
            //Set initial visibility
            this.setStepperVisibility('info',this.selectedEvent.show_info_in_welcome_dialog);
            this.setStepperVisibility('team',this.changeTeamFoto|| this.changeTeamName);
            this.setStepperVisibility('participants',this.selectedEvent.may_add_participants);

            let activeView=this._.first(this.visibleItems);
            this.wizardStep=(activeView)?activeView.id:1;
          }

          //Close if there are no visible items
          if(this.visibleItems.length<1){
            this.onClose();
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    title(){
      if(this.showStepTeam){
        if(this.changeTeamFoto){
          if(this.changeTeamName){
            return this.$t('welcomeTeamAndPhotoTitle')
          }else{
            return this.$t('welcomePhotoTitle')
          }
        }

        return this.$t('welcomeTeamPlaceholder');
      }else if(this.showStepParticipants){
        return this.$t('welcomeParticipantsTitle');
      }
      return this.eventTitle;
    },
    description(){
      if(this.showStepTeam){
        if(this.changeTeamFoto){
          if(this.changeTeamName){
            return this.$t('welcomeTeamAndPhotoMessage')
          }else{
            return this.$t('welcomePhotoError')
          }
        }

        return this.$t('welcomeTeamMessage');
      }else if(this.showStepParticipants){
        return this.$t('welcomeParticipantsMessage');
      }
      return ""
    },
    
    changeTeamFoto(){
      return (this.selectedEvent)?(this.selectedEvent.use_team_fotos && (this.selectedEvent.may_change_foto || (this.$refs.teamView && this.$refs.teamView.hasTeamPhoto))):false;
    },
    changeTeamName(){
      return (this.selectedEvent)?(this.selectedEvent.may_change_name):false;
    },
    visibleItems(){
      return this._.filter(this.items,(i)=>{return i && i.visible})
    },
    hasEventDescr(){
      return !this._.isEmpty(this.eventDescr);
    },
    eventDescr(){
      return Utils.replaceKeywords((this.selectedEvent)?this.selectedEvent.evcommentdt:'', this.getOfflineStatistic, this.allSpots, this.keywordExtras)
    },
    eventTitle(){
      return (this.selectedEvent)?this.selectedEvent.evnamedt:'';
    },
    showStepInfo(){
      let item=this.getStepperViewByName('info');
      return (item)?(this.wizardStep ==item.id):false;
    },
    hasStepTeam(){
      return !this._.isEmpty(this.getStepperViewByName('team'));
    },
    showStepTeam(){
      let item=this.getStepperViewByName('team');
      return (item)?(this.wizardStep ==item.id):false;
    },
    hasStepParticipants(){
      return !this._.isEmpty(this.getStepperViewByName('participants'));
    },
    showStepParticipants(){
      let item=this.getStepperViewByName('participants');
      return (item)?(this.wizardStep ==item.id):false;
    },

    lastItemId(){
      let lastItem=this._.last(this.visibleItems);
      return (lastItem)?lastItem.id:this.visibleItems.length;
    },
    completedWelcomeDialog(){
      return this.wizardStep >= this.lastItemId
    },
    showNextButton(){
      return (this.wizardStep < this.lastItemId)
    },
    showPrevButton(){
      let prevElementId=this.getPrevStepperViewId();
      let prevElement=this.getStepperViewById(prevElementId);
      return this.wizardStep > 1 && !this._.isEmpty(prevElement)
    }
  },
  methods: {
    setStepperVisibility(name,val){
      let item=this.getStepperViewByName(name);
      if(item) item.visible=val;
    },
    getNextStepperViewId(){
      return this.getStepperViewId(1);
    },
    getPrevStepperViewId(){
      let viewId = this.getStepperViewId(-1);

      //FIX - make getStepperView better 
      return (this.wizardStep==viewId)?1:viewId;
    },
    getStepperView(direction=0){
      let item=null;
      if(this._.isArray(this.items)){
        item=this._.find(this.items,(i)=>{
            return i.id>=(this.wizardStep + direction) && i.visible;
        }); 
      }

      return item;
    },
    getStepperViewId(direction=0){
      let item= this.getStepperView(direction);
      return (item)?item.id:1;
    },
    getStepperViewByName(name){
      if(this._.isArray(this.items)){
        return this._.find(this.items, { 'name': name,'visible':true }); 
      }
      return null;
    },
    getStepperViewById(id){
      if(this._.isArray(this.items)){
        return this._.find(this.items, { 'id': id,'visible':true }); 
      }
      return null;
    },
    onGoPrev(){
      this.goToStep(this.getPrevStepperViewId(-1));
    },
    onGoNext(){
      this.goToStep(this.getNextStepperViewId());
    },
          
    goToStep(nr){
      let isStepForward=(this.wizardStep<nr);
      this.wizardStep = nr;
      this.highestWizardStep=(isStepForward)?nr:this.highestWizardStep;
      window.scrollTo(0,0);//scroll to top
    },
    editableStep(step){
      if(step<=this.highestWizardStep){
        this.wizardStep=step;
      }
    },
    completed(step){
      return this.wizardStep == step
    },
    isClickableStepClass(step){
      return (step<=this.highestWizardStep)?'clickableStep':'';
    },
    // Sends the requests one after the other: the server rewrites the whole team row in
    // both calls, a concurrent createparticipants would overwrite the name setteamname just stored.
    storeSettings(){
      let requests=[];
      if(this.hasStepTeam &&  this.enteredTeamSettings && this.enteredTeamSettings.teamName){
        requests.push(()=>this.setTeamName(this.enteredTeamSettings.teamName));
      }

      if(this.hasStepParticipants && this.enteredParticipatSettings){
        requests.push(()=>this.setParticipantNames(this.enteredParticipatSettings));
      }

      if(!this._.isEmpty(requests)){
        requests.reduce((chain,request)=>chain.then(request).catch(()=>{}),Promise.resolve()).then(()=>{
          this.notifyTeamNameChanged();
        });
      }
    },
    onClose(){
      this.storeSettings();
      this.$emit('close');
    },
    onTeamSettingsComplete(data){
      //Hint: Teamfoto already uploaded
      

      if(data){
        if(data.teamPhoto){
          this.updateTeamPhoto(data.teamPhoto);
          this.notifyTeamPhotoChanged();
        }
        if(data.teamName){
          this.updateTeamName(data.teamName);
        }
      }

      this.enteredTeamSettings=data;
    },
    onParticipantsSettingsComplete(data){
      this.enteredParticipatSettings=data;
    },
    start(){
      if(!this.interval){
        this.interval = setInterval(() => {
          this.count++
          // console.log('touch' + this.count)
      }, 100)}
    },
    stop(){
      clearInterval(this.interval)
      this.interval = false
      if (this.count >= 40) {
        this.$emit('close');
      }
      this.count = 0
    },
    assignPseudoElementStyle() {
        this.spanColorValue = this.theme.footerIconColor;
        document.documentElement.style.setProperty('--span-step-color', this.spanColorValue);
        this.backgroundColorValue = this.theme.backgroundColor;
        document.documentElement.style.setProperty('--background-color', this.spanColorValue);
    },
    setPaginationWidth() {
      if(this.isMdAndUpDevice) {
          if(this.visibleItems.length === 3) {
            this.vStepperWidth = '60%';
          } else if(this.visibleItems.length === 2) {
            this.vStepperWidth = '40%';
          }
      } else if(this.isXsDevice) {
          if(this.visibleItems.length === 3) {
            this.vStepperWidth = '100%';
          } else if(this.visibleItems.length === 2) {
            this.vStepperWidth = '80%';
          }
      } else if(this.isSmDevice) {
          if(this.visibleItems.length === 3) {
            this.vStepperWidth = '60%';
          } else if(this.visibleItems.length === 2) {
            this.vStepperWidth = '40%';
          }
      } 
     if(this.isXsExtraSmallDevice) {
          if(this.visibleItems.length === 3) {
            this.vStepperWidth = '120%';
          } else if(this.visibleItems.length === 2) {
            this.vStepperWidth = '100%';
          }
      }
    }
  },
}
</script>

<style lang="scss">

.welcomeDialog .clickableStep{
 cursor: pointer;
}
.welcomeDialog .v-stepper__step{
  padding:3px!important;
}

.welcomeDialog .v-stepper__header{
  align-items: center;
  justify-content: center;
  box-shadow: none;
}

.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
  opacity: 1 !important;
  background-color: var(--span-step-color) !important;
}

.wellcome-button.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined)  {
  background-color: var(--btn-color) !important;
}

.white--text.theme--light.v-btn.v-btn--disabled .v-icon {
  color: var(--span-step-color) !important;
}

.wellcome {
  .v-card {
    background-color: var(--background-color);
  }
}


</style>